import MinusIcon from '@/icons/minus.svg';
import PlusIcon from '@/icons/plus.svg';
import {Media, MediaContextProvider} from '@/media';

import styles from './OpenButton.module.css';

interface OpenButtonProps {
	isOpen: boolean;

	onClick: (isOpen) => void;
}

export function OpenButton({isOpen, onClick}: OpenButtonProps) {
	return (
		<div className={styles.root} onClick={onClick}>
			<MediaContextProvider>
				<Media at="mobile">
					{isOpen ? <MinusIcon width={24} height={24} /> : <PlusIcon width={24} height={24} />}
				</Media>
				<Media greaterThanOrEqual="desktop">
					{isOpen ? <MinusIcon width={32} height={32} /> : <PlusIcon width={32} height={32} />}
				</Media>
			</MediaContextProvider>
		</div>
	);
}
